
import type { SVGProps } from 'react';
const SvgPeople = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#people_svg__a)">
      <path
        fill="#263E6A"
        d="M5.4 17.1v-1.543q0-.575.269-1.043t.746-.698q1.09-.526 1.964-.756a7 7 0 0 1 1.8-.23q.926 0 1.791.23.866.23 1.956.756.478.23.754.698t.277 1.043V17.1zm10.452 0v-1.543q0-1.035-.477-1.7a3.6 3.6 0 0 0-1.255-1.076q1.03.13 1.942.386.91.255 1.478.583.492.312.776.772t.284 1.035V17.1zm-5.674-5.272q-.985 0-1.612-.69-.628-.689-.628-1.774t.628-1.773q.627-.69 1.612-.69t1.613.69.627 1.773-.627 1.774-1.613.69m3.136 0q-.164 0-.366-.024a1.5 1.5 0 0 1-.366-.09q.36-.411.545-1.01.187-.6.187-1.34 0-.739-.187-1.305a3.6 3.6 0 0 0-.545-1.043 3 3 0 0 1 .732-.115q.986 0 1.613.69t.627 1.773-.627 1.774-1.613.69m-7.018 4.287h7.765v-.558q0-.263-.142-.51a.8.8 0 0 0-.351-.344q-1.076-.525-1.807-.707a6.6 6.6 0 0 0-1.583-.18q-.85 0-1.59.18-.739.18-1.814.707a.77.77 0 0 0-.344.345 1.05 1.05 0 0 0-.134.509zm3.882-5.272q.583 0 .963-.42.381-.417.381-1.059 0-.64-.38-1.059a1.25 1.25 0 0 0-.964-.419q-.582 0-.963.42-.38.417-.38 1.058t.38 1.06q.381.42.963.419"
      />
    </g>
    <defs>
      <clipPath id="people_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPeople;
